import { defineQuartzConfig } from 'quartz-core/config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'app',
  historyBasename: '/page-details/:portalId',
  htmlTitle: 'Page Details UI',
  htmlTitleLangKey: 'page-details-ui.htmlTitle'
});